import React, { useState } from 'react';
import Input from '../../components/inputComponent/Input';
import axios from 'axios';
import { apiPath, baseUrl } from '../../global';
import './Login.css';
import bgImg from '../../assets/icons/loginImage/image2.webp';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import logo from '../../assets/logo/sanaLogo.png';
import Modal from '../../components/modal/Modal';

export default function Login(props) {

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);
        const id = toast.loading("Please wait...");
        
        axios.post(`${baseUrl}/authenticate`, {
            userName: e.target.username.value,
            password: e.target.password.value
        }, {headers: {"Authorization":''}}).then(async res => {
            if(res.status === 200)
            {
                var decodedData = jwtDecode(res.data.jwt);
                localStorage.setItem("sanaToken",res.data.jwt);
                //console.log(decodedData);
                
                props.update({...decodedData.role[0].tokenPayload});
                     
                toast.update(id, { render: "LoggedIn Successfully", type: "success", isLoading: false , autoClose: true, closeButton: true});
            }
        }).catch(err => {
            console.log(err);
            if(err.status === 401)
            {
                toast.update(id, { render: "Incorrect username or password", type: "error", isLoading: false , autoClose: true, closeButton: true});
            }
            else
                toast.update(id, { render: err.message, type: "error", isLoading: false , autoClose: true, closeButton: true});
        }).finally(() =>{
            setLoading(false);
        })
        
    }

    const close = () => setShow(false);

    const handleForgot = (e) => {
        e.preventDefault();

        setLoading(true);
        const id = toast.loading("Please wait...");
        
        axios.post(`${apiPath}/general/forgotPassword`, {
            email: e.target.email.value
        }, {headers: {"Authorization":''}}).then(async res => {
            if(res.data.success)
            {
                toast.update(id, { render: res.data.message, type: "success", isLoading: false , autoClose: true, closeButton: true});
            }
            else{
                toast.update(id, { render: res.data.message, type: "error", isLoading: false , autoClose: true, closeButton: true});
            }
        }).catch(err => {
            console.log(err);
            
            toast.update(id, { render: err.message, type: "error", isLoading: false , autoClose: true, closeButton: true});
        }).finally(() =>{
            setLoading(false);
            close();
        })
    }

  return (
    <div className='login-main' style={{backgroundImage:`url(${bgImg})`, backgroundRepeat:'no-repeat', backgroundPosition:'center', backgroundSize:'cover'}}>
        
        <div className='custom-card login-card' style={{paddingBottom:'40px'}}>
            <img loading='lazy' src={logo} style={{marginBottom: '40px'}}/>
            {/* <h2 style={{textAlign:'center', marginTop:'10px', marginBottom:'40px'}}>Logo Here</h2> */}
            <form className='login-form' onSubmit={handleSubmit}>
                <Input label={"Username"} type='text' placeholder="Enter Username/Email" name="username" required/>
                <Input label={"Password"} type='password' placeholder="Enter Password" name="password" style={{marginBottom: '10px'}} required/>
                <Input type='submit' value={"Login"} disabled={loading} />
            </form>

            <p style={{color:'var(--secondary-color)', textAlign:'center', cursor:'pointer'}} onClick={() => setShow(true)}>Forgot password?</p>
            <p className='disclaimer-text'>
                Benvenuti! <br />
                Da qui potrete accedere alla propria Dashboard di Gestione. <br />
                Per maggiori info info@sanarapida.it <br />
                Legionella360 | PureAir24

            </p>
        </div>

        { show ?
                              
            <Modal close={close} style={{width:'40%'}} formName="Request Reset Link" bg='rgb(0, 0, 0, .7)'> 
            
                <form className='forgot-pass' onSubmit={handleForgot}>
                      
                    
                    <Input label={"Email"} required={true} type='email' placeholder="Enter Your Registered Email" name="email" />
                    
            
                    <div style={{display: 'flex', justifyContent:'flex-end'}}>
                        <Input type='submit' value={'Submit'} minWidth='100px' disabled={loading}/>
                    </div>
                </form>
            
            </Modal> : null
        }

    </div>
  )
}
